import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Map } from 'immutable'
import ImmutablePropTypes from 'react-immutable-proptypes'
import compose from 'recompose/compose'
import _get from 'lodash/get'
import { connect } from 'react-redux'
import Sherpa, { TYPE_LARGE } from '../Sherpa/index'
import { connect as connectPage, PAGE_SEO_TYPE_MANUAL } from '../Page/connect'
import { get as getConfig } from '../../config/index'
import { getPageState, handleRedirect, pageStates } from './utils'
import GoRemoteLogin from './GoRemoteLogin'
import GoAddToPlaylistRest from './GoAddToPlaylistRest'
import GoAddToPlaylist from './GoAddToPlaylist'
import GoCreatePlaylistRest from './GoCreatePlaylistRest'
import GoCreatePlaylist from './GoCreatePlaylist'
import GoSku from './GoSku'

const config = getConfig()
const myLibraryGQLEnabled = !!_get(config, ['features', 'myLibraryPageGraphQL'])

function GoPageV2 (props) {
  const {
    inboundTracking,
    staticText,
    location,
    history,
    user,
    auth,
  } = props

  const [pageState, setPageState] = useState()
  const url = _get(location, ['query', 'url'])

  useEffect(() => {
    if (pageState === pageStates.GO_REDIRECT) {
      handleRedirect({
        history,
        auth,
        user,
        url,
      })
    }
  }, [pageState])

  useEffect(() => {
    if (inboundTracking.get('initialized') && inboundTracking.has('data') && !inboundTracking.get('processing')) {
      setPageState(getPageState(location))
    }
  }, [inboundTracking])

  return (
    <div className="go-page">
      <Sherpa type={TYPE_LARGE} />
      <p className="go-page__message">
        {staticText.get('oneMomentPleaseWeAreLocatingYourPath')}
      </p>
      {pageState === pageStates.GO_SKU
        && <GoSku location={location} history={history}/>
      }
      {pageState === pageStates.GO_REMOTE_LOGIN
        && <GoRemoteLogin location={location} history={history}/>
      }
      {pageState === pageStates.GO_ADD_TO_PLAYLIST && !myLibraryGQLEnabled
        && <GoAddToPlaylistRest location={location} history={history}/>
      }
      {pageState === pageStates.GO_ADD_TO_PLAYLIST && myLibraryGQLEnabled
        && <GoAddToPlaylist location={location} history={history}/>
      }
      {pageState === pageStates.GO_CREATE_PLAYLIST && !myLibraryGQLEnabled
        && <GoCreatePlaylistRest location={location} history={history}/>
      }
      {pageState === pageStates.GO_CREATE_PLAYLIST && myLibraryGQLEnabled
        && <GoCreatePlaylist location={location} history={history}/>
      }
    </div>
  )
}

GoPageV2.propTypes = {
  inboundTracking: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
}

export default compose(
  connect(
    (state) => ({
      staticText: state.staticText.getIn(['data', 'goPage', 'data'], Map()) || Map(),
      inboundTracking: state.inboundTracking,
      auth: state.auth,
      user: state.user,
    }),
  ),
  connectPage({ seoType: PAGE_SEO_TYPE_MANUAL }),
)(GoPageV2)
